{
  "type": "object",
  "properties": {
    "metaData": {
      "type": "object",
      "properties": {
        "fragmentInstance": {
          "type": "string"
        },
        "sig": {
          "type": "string"
        }
      }
    },
    "id": {
      "type": "string"
    },
    "type": {
      "type": "string"
    }
  }
}
